import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatAutocompleteModule    } from '@angular/material/autocomplete';
import { MatButtonModule          } from '@angular/material/button';
import { MatButtonToggleModule    } from '@angular/material/button-toggle';
import { MatCardModule            } from '@angular/material/card';
import { MatCheckboxModule        } from '@angular/material/checkbox';
import { MatChipsModule           } from '@angular/material/chips';
import { MatDatepickerModule      } from '@angular/material/datepicker';
import { MatDialogModule          } from '@angular/material/dialog';
import { MatExpansionModule       } from '@angular/material/expansion';
import { MatGridListModule        } from '@angular/material/grid-list';
import { MatIconModule            } from '@angular/material/icon';
import { MatInputModule           } from '@angular/material/input';
import { MatListModule            } from '@angular/material/list';
import { MatMenuModule            } from '@angular/material/menu';
//import { MatNativeDateModule      } from '@angular/material/';
import { MatProgressBarModule     } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule           } from '@angular/material/radio';
//import { MatRippleModule          } from '@angular/material/';
import { MatSelectModule          } from '@angular/material/select';
import { MatSidenavModule         } from '@angular/material/sidenav';
import { MatSliderModule          } from '@angular/material/slider';
import { MatSlideToggleModule     } from '@angular/material/slide-toggle';
import { MatSnackBarModule        } from '@angular/material/snack-bar';
import { MatTabsModule            } from '@angular/material/tabs';
import { MatTableModule           } from '@angular/material/table';
import { MatToolbarModule         } from '@angular/material/toolbar';
import { MatTooltipModule         } from '@angular/material/tooltip';
import { MatDividerModule         } from '@angular/material/divider';
//import { MatNavList               } from '@angular/material/';
import { MatFormFieldModule       } from '@angular/material/form-field';
//import { MatOptionModule          } from '@angular/material';
import { MatPaginatorModule       } from '@angular/material/paginator';

const materialModules = [
    MatIconModule,
    MatToolbarModule,
    MatGridListModule,
    MatMenuModule,
    MatTabsModule,
    MatDividerModule,
    MatFormFieldModule,
    //MatOptionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    materialModules
  ],

  exports: [
    materialModules    
  ]
})
export class MaterialModule { }
